export default "__VITE_ASSET__DTFLCCn9__"